<template>
  <div id="mbmcookie" v-if="!hasCookiesConsentAccepted && (!forceLeave || hasCookiesConsentAccepted)">
    <div class="TEST">
      <section class="m-4">
        <article class="text-center">
          <h2 style="color:white; font-size: 32px;" class="d-lg-none">Cookie-Richtlinien</h2>
          <h2 style="color:white" class="d-none d-lg-block">Cookie-Richtlinien</h2>
          <p class="cookieText d-lg-none" style="font-size: 14px;">Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzererfahrung auf unseren
            Webseiten zu geben.
            Bitte willigen Sie in die Verwendung von Cookies ein, indem Sie weiter unten auf „Alle akzeptieren“ klicken.
            Einzelheiten zu den Arten von Cookies, ihrem Zweck und den beteiligten Stellen finden Sie
            in unserer Cookie-Richtlinie. Sie können die Cookies auch ablehnen
            (mit Ausnahme unbedingt erforderlicher Cookies).
          </p>
          <p class="cookieText d-none d-lg-block">Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzererfahrung auf unseren
            Webseiten zu geben.
            Bitte willigen Sie in die Verwendung von Cookies ein, indem Sie weiter unten auf „Alle akzeptieren“ klicken.
            Einzelheiten zu den Arten von Cookies, ihrem Zweck und den beteiligten Stellen finden Sie
            in unserer Cookie-Richtlinie. Sie können die Cookies auch ablehnen
            (mit Ausnahme unbedingt erforderlicher Cookies).
          </p>
          <router-link to="/legal" @click="triggerForce" style="font-size: 16px;" class="d-lg-none">Datenschutzerklärung</router-link>
          <router-link to="/legal" @click="triggerForce" style="font-size: 24px;" class="d-none d-lg-block">Datenschutzerklärung</router-link>
          <form class="pt-2 row row-cols-1 row-cols-md-2 d-lg-none" @submit.prevent="acceptCookie">
            <div class="p-4">
              <button id="acceptAll" type="submit" class="gradient-button baseButton baseButtonPhone col"
                @click="beforeAccept(true, true, true, true)">
                Alle Akzeptieren</button>
            </div>
            <div class="p-4">
              <button id="denyAll" type="submit" class="gradient-button baseButton baseButtonPhone col"
                @click="beforeAccept(true, false, false, false)"> Alle Ablehnen</button>
            </div>
          </form>
          <form class="pt-2 row row-cols-1 row-cols-md-2 d-none d-lg-flex" @submit.prevent="acceptCookie">
            <div class="p-4">
              <button id="acceptAll" type="submit" class="gradient-button baseButton col"
                @click="beforeAccept(true, true, true, true)">
                Alle Akzeptieren</button>
            </div>
            <div class="p-4">
              <button id="denyAll" type="submit" class="gradient-button baseButton col"
                @click="beforeAccept(true, false, false, false)"> Alle Ablehnen</button>
            </div>
          </form>
        </article>
      </section>
    </div>
  </div>
</template>
  
<script>
import Cookies from 'js-cookie';
// Obwohl stand 25.07.2023 nur Cookies akzeptiert oder Abgelehnt werden können habe ich die Cookievariation
// dennoch drin gelassen um Zukünftig die Implementierung zu vereinfachen
export default {
  data() {
    return {
      hasCookiesConsentAccepted: false,
      functionalCookie: false,
      performanceCookie: false,
      thirdCookie: false,
    };
  },
  mounted() {
    this.hasCookiesConsentAccepted = this.checkCookie('consent');

    this.functionalCookie = this.checkCookie('functionalCookie');
    this.performanceCookie = this.checkCookie('performanceCookie');
    this.thirdCookie = this.checkCookie('thirdPartyCookie');
  },
  computed: {
    forceLeave() {
      return this.$store.getters.forceLeave;
    }
  },
  methods: {
    triggerForce() {
      this.$store.commit('forceLeave');
    },
    beforeAccept(consent, functional, performance, third) {
      this.hasCookiesConsentAccepted = consent;
      this.functionalCookie = functional;
      this.performanceCookie = performance;
      this.thirdCookie = third;
      this.acceptCookie()
    },
    checkCookie(Name) {
      const consentCookieValue = Cookies.get(Name);
      return consentCookieValue !== undefined;
    },
    acceptCookie() {

      Cookies.set('consent', 'accepted', { expires: 365, path: '/', sameSite: 'None', secure: true });
      if (this.functionalCookie) {
        Cookies.set('functionalCookie', 'accepted', { expires: 365, path: '/', sameSite: 'None', secure: true });
      }
      if (this.performanceCookie) {
        Cookies.set('performanceCookie', 'accepted', { expires: 365, path: '/', sameSite: 'None', secure: true });
      }
      if (this.thirdCookie) {
        Cookies.set('thirdPartyCookie', 'accepted', { expires: 365, path: '/', sameSite: 'None', secure: true });
      }

      this.hasCookiesConsentAccepted = true;


      //finished cookies - now use cookie to show, or dont show i frame in contact dont forget unit test
    }
  }
};

</script>
  
<style scoped>
.baseButton {
  height: 60px;
  width: 300px;
}
.baseButtonPhone{
  height: 50px;
  width: 240px;
}
.TEST {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cookieButton {
  border-radius: 12px;
  background: white;
  color: gray;
  border-color: gray;
  box-shadow: none;
}

p {
  color: #ffffff;
}

.cookieText {
  font-size: 18px;
  margin: 0 12px;
}

#mbmcookie {
  display: flex;
  justify-content: center;
  position: fixed;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
}

a {
  color: #ffffff;
  font-size: 10px;
  text-decoration: underline;
}

a:hover {
  color: #ffffff;
  text-decoration: none;
}

#mbmcookie a.button {
  cursor: pointer;
  background: linear-gradient(90deg, rgba(89, 81, 187, 1) 0%, rgba(189, 89, 151, 1) 100%);
  padding: 20px 20px;
  text-decoration: none;
  margin-top: 10px;
  border-radius: 16px;
  font-weight: bold;
  color: #ffffff;
}

#mbmcookie a.button:hover {
  background: linear-gradient(90deg, rgb(73, 66, 151) 0%, rgb(155, 73, 123) 100%);
}

label {
  font-size: 14px;
}
</style>